document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#property-search-form");

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    // Obtém os valores dos campos do formulário
    const propertyType = document.querySelector("#type").value;
    const location = document.querySelector("#location").value;
    const priceRange = document.querySelector("#price-range").value; // Faixa de preço

    // Ajuste para garantir que os valores sejam compatíveis com os metafields cadastrados
    const priceFilter = {
      "De até 300K": "De até 300K",
      "Entre 300k e 800k": "Entre 300k e 800k",
      "Acima de 800k": "Acima de 800k",
    };

    // Converte o valor selecionado para o formato correto do metafield
    const formattedPrice = priceFilter[priceRange] || "";

    // Monta a URL com os valores do metafield
    const queryParams = new URLSearchParams({
      "filter.p.m.custom_properties.property_type": propertyType,
      "filter.p.m.custom_properties.property_region": location,
      "filter.p.m.custom_properties.price": formattedPrice, // Faixa de preço no formato correto
    });

    const url = `/collections/all?${queryParams.toString()}`;
    console.log("Redirecionando para:", url); // Debug

    // Redireciona para a URL gerada
    window.location.href = url;
  });
});
